/* eslint-disable no-underscore-dangle */
/* eslint-disable import/no-unresolved */
/* eslint-disable import/extensions */
import React from 'react';
import { inject, observer } from 'mobx-react';
import './DashboardShop.less';
import KUDhome from '../KUD home/index';

function DashboardShop() {
  return (
    <KUDhome />
  );
}

export default inject('authStore')(observer(DashboardShop));
